import { Space } from 'antd';
import { ShowLink } from '@/components/common/ShowLink';

interface EntitlementLinksProps {
  ids: number[];
  /** Open in a new tab — for links shown inside a modal mid-flow. */
  newTab?: boolean;
}

export const EntitlementLinks = ({ ids, newTab }: EntitlementLinksProps) => (
  <Space size="small" wrap>
    {ids.map((id) => (
      <ShowLink
        key={id}
        resource="monetization.entitlements"
        id={id}
        newTab={newTab}
      >
        #{id}
      </ShowLink>
    ))}
  </Space>
);
